import React from "react";

export default function HabitatManagementIcon(props) {
  return(
      <img src="/Icons/habitatManagement.svg" alt="habitat management" {...props}/>
  )
}
